export default __webpack_public_path__ + "static/media/giftbox.01ea8845.webp";